// src/pages/B2B/crm/components/VenueFilters.tsx
import React from 'react';
import { PIPELINE_STAGES, PipelineStage, VenueListFilters } from '../api/types';

interface Props {
  filters: VenueListFilters;
  onChange: (next: VenueListFilters) => void;
}

export function VenueFilters({ filters, onChange }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <input
        type="text"
        placeholder="Search venues..."
        value={filters.search ?? ''}
        onChange={(e) => onChange({ ...filters, search: e.target.value || undefined })}
        className="flex-1 min-w-[240px] bg-[#0f0f1a] border border-[#2a2a3e] rounded-md px-3 py-1.5 text-sm text-gray-200 placeholder-gray-500"
      />
      <select
        value={filters.stage ?? ''}
        onChange={(e) =>
          onChange({ ...filters, stage: (e.target.value || undefined) as PipelineStage | undefined })
        }
        className="bg-[#0f0f1a] border border-[#2a2a3e] rounded-md px-3 py-1.5 text-sm text-gray-200"
      >
        <option value="">All stages</option>
        {PIPELINE_STAGES.map(s => <option key={s} value={s}>{s}</option>)}
      </select>
      <label className="flex items-center gap-2 text-sm text-gray-300">
        <input
          type="checkbox"
          checked={!!filters.flag_for_ray}
          onChange={(e) => onChange({ ...filters, flag_for_ray: e.target.checked || undefined })}
        />
        Flagged for Ray
      </label>
    </div>
  );
}
